// extracted by mini-css-extract-plugin
module.exports = {"info":"SnippetInfoIcon_info__1BtWB","infoText":"SnippetInfoIcon_infoText__7SIC-"};